import { Brand } from "@/shared/ui/Brand";
import { UtilityCluster } from "./UtilityCluster";

/**
 * TopBar — **폰 전용** 상단바. 로고(폰엔 사이드바가 없어 로고 자리가 여기뿐)와
 * 유틸리티 묶음(언어·테마·음성·경보).
 *
 * 데스크톱(lg 이상)에서는 그리지 않는다 — 이 넷 말고는 빈 60px 띠였다(2026-09-15).
 * 데스크톱의 묶음은 통합 관제 헤더([전체화면] 왼쪽)와 사이드바 아래에 있다.
 * `--header-h` 도 lg 에서 0 이라(tokens.css) `--chrome-top` 기준 레이아웃이 같이 줄어든다.
 */
export function TopBar() {
  return (
    <header
      className={
        "lg:hidden sticky top-0 z-30 h-[var(--header-h)] " +
        "bg-[color-mix(in_oklab,var(--bg)_82%,transparent)] backdrop-blur-md " +
        "border-b border-[var(--separator)]"
      }
    >
      <div className="h-full px-5 flex items-center gap-4">
        <Brand height={18} className="shrink-0" />
        <UtilityCluster className="ml-auto" />
      </div>
    </header>
  );
}
